export const doctorTableTemplate = [
  {
    id: 'crm',
    description: 'CRM',
    originalId: 'crm',
    width: 150,
  },
  {
    id: 'name',
    description: 'Nome',
    originalId: 'name',
    width: 300,
  },
  {
    id: 'document_number',
    description: 'CPF/CNPJ',
    originalId: 'document_number',
    width: 200,
  },
  {
    id: 'rg',
    description: 'RG',
    originalId: 'rg',
    width: 120,
  },
  {
    id: 'email',
    description: 'E-mail',
    originalId: 'email',
    width: 300,
  },
  {
    id: 'phone',
    description: 'Telefone',
    originalId: 'phone',
    width: 200,
  },
  {
    id: 'marital_status',
    description: 'Estado Civil',
    originalId: 'marital_status',
    width: 200,
  },
  {
    id: 'formattedCity',
    description: 'Cidade',
    originalId: 'formattedCity',
    width: 200,
  },
  {
    id: 'formattedState',
    description: 'UF',
    originalId: 'formattedState',
    width: 200,
  },
  {
    id: 'formattedActive',
    description: 'Ativo',
    originalId: 'formattedActive',
    width: 200,
  },
];
